var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { managementService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { FilterService } from '~/utils/filter.service';
var SystemLogService = /** @class */ (function () {
    function SystemLogService() {
    }
    /**
     * 系统日志多条件的查询
     */
    SystemLogService.prototype.getAllSystemLogs = function (data, page) {
        return this.netService.send({
            server: managementService.systemLogController.getAllSystemLogs,
            data: {
                userRealName: data.userRealName,
                operatorTimeStart: FilterService.dateRanageFormat(data.operatorTime).start,
                operatorTimeEnd: FilterService.dateRanageFormat(data.operatorTime).end
            },
            page: page
        });
    };
    __decorate([
        Inject(NetService)
    ], SystemLogService.prototype, "netService", void 0);
    return SystemLogService;
}());
export { SystemLogService };
